import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export enum EmotoradEventTypes {
    "call" = "21259c2b-3ec7-55f5-8dab-31ed62190e09",
    /** First journey event (Leads) — emotoradSetup.md; UUID unchanged from legacy `enquiry` template id. */
    "lead" = "84284250-34ef-57af-b378-d317751aa429",
    "walkin" = "ab175022-d2a7-41ba-80a8-95d3882e60aa",
    "testride" = "9ae0a65a-5212-46b8-964f-84c0b07cab24",
    "sales" = "6c6f2152-5a37-48a2-8942-95885a42ca68",
    "dispositionTracker" = "f3a1b2c4-d5e6-4f7a-8b9c-0d1e2f3a4b5c",
}

// Stable migration IDs for direct tooling/debugging. Runtime code resolves these columns from template configuration.
export const EMOTORAD__EVENT__CALL__DISPOSITION__COLUMN_ID = "01a6209b-ef5d-40ee-a8f2-b0540e2f1231" as Uuid;

export const EMOTORAD__EVENT__LEAD__DISPOSITION__COLUMN_ID = "a8f0dd89-5df1-4076-aafb-57e768be01a6" as Uuid;

export const EMOTORAD__EVENT__SALE__DISPOSITION__COLUMN_ID = "e5c526e4-e149-43af-a52f-f7eac46b0f32" as Uuid;

export const EMOTORAD__EVENT__TEST_RIDE__DISPOSITION__COLUMN_ID = "2be0f527-f7ea-4f1b-86b5-55bc49296c40" as Uuid;

export const EMOTORAD__EVENT__WALK_IN__DISPOSITION__COLUMN_ID = "10868cb2-8888-4f59-91e4-98ff3ba15e27" as Uuid;

export const EMOTORAD__EVENT__WALKIN__L1_DISPOSITION__COLUMN_ID = "c2b8e9f1-4a3d-4c8e-9f2a-7b1e4d6c8a00" as Uuid;

export const EMOTORAD__EVENT__WALKIN__L2_DISPOSITION__COLUMN_ID = "15f0fce8-b2f8-4f8b-9475-402eb3ccd2ef" as Uuid;

export const EMOTORAD__EVENT__WALKIN__L3_DISPOSITION__COLUMN_ID = "ff8e0e26-7ac8-4823-a3d1-19508bc01a08" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__L1_DISPOSITION__COLUMN_ID = "d7314f9a-6e2c-41b8-8f61-9c4a2e7d1b00" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__L2_DISPOSITION__COLUMN_ID = "e84250ab-7f3d-52c9-9072-ad5b3f8e2c11" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__L3_DISPOSITION__COLUMN_ID = "f95361bc-804e-63da-a183-be6c40a9f3d2" as Uuid;

export const EMOTORAD__EVENT__CALL__L1_DISPOSITION__COLUMN_ID = "7d83a61a-969f-4bda-8d99-bab713ee6611" as Uuid;

export const EMOTORAD__EVENT__CALL__L2_DISPOSITION__COLUMN_ID = "4d56151d-59a1-458e-81ba-f0686eb40cb2" as Uuid;

export const EMOTORAD__EVENT__CALL__L3_DISPOSITION__COLUMN_ID = "edf5341d-47dd-43bd-a3dc-ce0a55a0d7e0" as Uuid;

export const EMOTORAD__CALL__SCHEDULE__FORM__ID = "37859db2-41cb-54d4-90f8-b6f75b1ae90a" as Uuid;

export const EMOTORAD__CALL__LOG__FORM__ID = "56645605-26e8-5b14-a0e8-9284b6344f1c" as Uuid;

export const EMOTORAD__CALL__EDIT__FORM__ID = "186ca625-5245-5086-a2ba-b2eb1f778d18" as Uuid;

export const EMOTORAD__WALKIN__SCHEDULE__FORM__ID = "75d608c0-f583-4fe4-9272-6234384286d3" as Uuid;

export const EMOTORAD__WALKIN__LOG__FORM__ID = "0d936309-abf5-4c31-b4ef-0e55ffc91570" as Uuid;

export const EMOTORAD__WALKIN__EDIT__FORM__ID = "e0e1b8fe-277c-4d51-a162-e708582cdd48" as Uuid;

export const EMOTORAD__TESTRIDE__SCHEDULE__FORM__ID = "11545957-ae52-4923-864c-756f0dda8ff1" as Uuid;

export const EMOTORAD__TESTRIDE__LOG__FORM__ID = "b1e803cd-90a0-43bf-adcd-8d89c18324c9" as Uuid;

export const EMOTORAD__TESTRIDE__EDIT__FORM__ID = "f8879acc-f313-42b9-8f54-6a43e344cbcd" as Uuid;

export const EMOTORAD__SALES__SCHEDULE__FORM__ID = "1b71e3a4-4e6e-4c12-94d3-daba10869540" as Uuid;

export const EMOTORAD__SALES__LOG__FORM__ID = "6c4456ed-67d5-45ad-a9ad-0fa72ebe58dc" as Uuid;

export const EMOTORAD__SALES__EDIT__FORM__ID = "8a3c0987-ad5f-49af-8849-311cf8ccceda" as Uuid;

export const EMOTORAD__EVENT__CALLS__CALL_TYPE__COLUMN_ID = "69dda03f-78e7-5f05-983c-3f85d5d0872f" as Uuid;

export const EMOTORAD__EVENT__CALLS__STATUS__COLUMN_ID = "8a2dd16e-86b1-5410-83c4-a444eb0d1ff4" as Uuid;

export const EMOTORAD__EVENT__CALLS__CALL_DISPOSITION__COLUMN_ID = "68718f22-f178-549c-a64e-17a905ad1a83" as Uuid;

export const EMOTORAD__EVENT__CALLS__LOGGED_CALL_REMARKS__COLUMN_ID = "4a50a3ca-7d65-5434-b4fd-a41ba8ef1565" as Uuid;

export const EMOTORAD__EVENT__CALLS__CALL_START_TIME__COLUMN_ID = "20905e7b-4ce5-5c67-bab5-09c339597f4f" as Uuid;

export const EMOTORAD__EVENT__CALLS__CALL_END_TIME__COLUMN_ID = "e63a683a-5ab5-5626-97a6-be63bcfdc14a" as Uuid;

export const EMOTORAD__EVENT__CALLS__CALL_DURATION__COLUMN_ID = "26e664aa-f116-556b-bd0f-6116a9751ae0" as Uuid;

export const EMOTORAD__EVENT__CALLS__SCHEDULED_BY__COLUMN_ID = "466aac9f-cad8-54cc-8924-11fc51e531ef" as Uuid;

export const EMOTORAD__EVENT__CALLS__SCHEDULED_ON__COLUMN_ID = "c40f9bb5-f2b9-5cf9-b917-ae80a3dbcc1c" as Uuid;

export const EMOTORAD__EVENT__CALLS__LOGGED_BY__COLUMN_ID = "64cd368b-5014-5a80-81be-3ca4db2dd447" as Uuid;

export const EMOTORAD__EVENT__CALLS__LOGGED_ON__COLUMN_ID = "21d3e9d5-3e3f-5a84-b37b-014f187fbe07" as Uuid;

export const EMOTORAD__EVENT__CALLS__CANCELLED_BY__COLUMN_ID = "b655a933-9428-5991-ab23-59f6da62871b" as Uuid;

export const EMOTORAD__EVENT__CALLS__CANCELLED_ON__COLUMN_ID = "ddd8ce7e-2ca4-5001-8a33-3dffb105f9ae" as Uuid;

export const EMOTORAD__EVENT__CALLS__CANCELLATION_REMARKS__COLUMN_ID = "bf25c9eb-2300-59cc-be90-501910acc554" as Uuid;

export const EMOTORAD__EVENT__CALLS__UTM_PLATFORM__COLUMN_ID = "e5390422-ba78-5917-a0f0-e5efb2b3cd4f" as Uuid;

export const EMOTORAD__EVENT__CALLS__UTM_SOURCE__COLUMN_ID = "82104c0a-6a1f-55b8-857d-3d38b1992999" as Uuid;

export const EMOTORAD__EVENT__CALLS__UTM_MEDIUM__COLUMN_ID = "57ddc20d-4980-53b4-b000-597571233674" as Uuid;

export const EMOTORAD__EVENT__CALLS__UTM_CAMPAIGN__COLUMN_ID = "16e4d340-f1dc-5d92-b17b-822755c55808" as Uuid;

export const EMOTORAD__EVENT__CALLS__UTM_TERM__COLUMN_ID = "7ae0a413-731d-5b62-a8e1-c0a0a9d1ef57" as Uuid;

export const EMOTORAD__EVENT__CALLS__UTM_CONTENT__COLUMN_ID = "32fba466-e0fe-5f63-a2d1-3cf5f06b0c6f" as Uuid;

export const EMOTORAD__EVENT__CALLS__CUSTOMER_PINCODE__COLUMN_ID = "996c6139-fbbd-44b2-ae8c-e953adf0916a" as Uuid;

export const EMOTORAD__EVENT__CALLS__MODEL_VARIANT__COLUMN_ID = "893fa6ab-e65c-4b8f-8190-9ce37f5d0882" as Uuid;

export const EMOTORAD__EVENT__CALLS__LAST_CALL_DATE__COLUMN_ID = "72d896fa-4665-4e2d-b27d-539951840df3" as Uuid;

export const EMOTORAD__EVENT__CALLS__CUSTOMER_STATE__COLUMN_ID = "782c1a41-9cc4-48c5-abb5-b70d84186b76" as Uuid;

export const EMOTORAD__EVENT__CALLS__CUSTOMER_CITY__COLUMN_ID = "700a8cbc-ae59-4980-97bd-7c594f5bef22" as Uuid;

export const EMOTORAD__EVENT__CALLS__CURRENT_PLATFORM__COLUMN_ID = "e904068e-3206-4dcf-b311-ce699789b155" as Uuid;

export const EMOTORAD__EVENT__CALLS__PURCHASE_TIMELINE__COLUMN_ID = "68a2883c-800a-4157-94ef-bb22a8b3815a" as Uuid;

export const EMOTORAD__EVENT__CALLS__EXPLORING_FOR__COLUMN_ID = "ff7789c3-3211-4ba2-9614-a0a00081e189" as Uuid;

export const EMOTORAD__EVENT__CALLS__PRIMARY_RIDING_PURPOSE__COLUMN_ID = "545e2943-e260-413c-90bb-a5dc19fd0c62" as Uuid;

export const EMOTORAD__EVENT__CALLS__HEIGHT_OF_RIDER__COLUMN_ID = "1ca86e71-5ecf-42af-a8d8-20aaf5c285b0" as Uuid;

export const EMOTORAD__EVENT__CALLS__EXPECTED_RIDING_FREQUENCY__COLUMN_ID = "d8960822-7968-4748-8618-dc75e3cd6be8" as Uuid;

export const EMOTORAD__EVENT__CALLS__MODIFIED_BY__COLUMN_ID = "fd68b042-62c9-468c-b110-08c69a338b75" as Uuid;

export const EMOTORAD__EVENT__CALLS__MODIFIED_ON__COLUMN_ID = "f9b895d9-b723-4cba-a1ae-a671b7ad7114" as Uuid;

export const EMOTORAD__EVENT__CALLS__FOLLOW_UP_REQUIRED__COLUMN_ID = "d54bd296-e54d-4f8e-a83e-b1a685872199" as Uuid;

export const EMOTORAD__EVENT__CALLS__FOLLOW_UP_DATE__COLUMN_ID = "46613c64-21b6-4142-843a-7f9590c2e524" as Uuid;

export const EMOTORAD__EVENT__CALLS__INPUT_TYPE__COLUMN_ID = "4f502e87-deff-487a-85ea-f1c3cfa27371" as Uuid;

export const EMOTORAD__EVENT__CALLS__INPUT_SOURCE__COLUMN_ID = "abf0510f-d885-472a-88dc-8d697d77bd2a" as Uuid;

export const EMOTORAD__EVENT__CALLS__TEST_RIDE_TAKEN__COLUMN_ID = "94892646-673f-4a32-a2ba-b02298fc02ea" as Uuid;

export const EMOTORAD__EVENT__WALKINS__STATUS__COLUMN_ID = "36acc38f-8b59-490c-ba7d-936b6015beb3" as Uuid;

export const EMOTORAD__EVENT__WALKINS__DISPOSITION__COLUMN_ID = "e5629230-9a62-4b42-9a58-cfaf2fe9423d" as Uuid;

export const EMOTORAD__EVENT__WALKINS__REMARKS__COLUMN_ID = "35964fe8-4d62-4539-878b-ebaa1d3eefcd" as Uuid;

export const EMOTORAD__EVENT__WALKINS__SCHEDULED_BY__COLUMN_ID = "71bf4cb0-5ecc-4068-9626-1ff324314707" as Uuid;

export const EMOTORAD__EVENT__WALKINS__SCHEDULED_ON__COLUMN_ID = "3d28fa38-2aaf-48aa-b4ba-03a726114ac4" as Uuid;

export const EMOTORAD__EVENT__WALKINS__LOGGED_BY__COLUMN_ID = "a8bbecbb-3b4d-41d2-b8f0-fca841411296" as Uuid;

export const EMOTORAD__EVENT__WALKINS__LOGGED_ON__COLUMN_ID = "c50c22aa-e6e3-4b26-95b3-0295cce64aad" as Uuid;

export const EMOTORAD__EVENT__WALKINS__CANCELLED_BY__COLUMN_ID = "21c9b81a-5cb8-4389-bde9-045273da2897" as Uuid;

export const EMOTORAD__EVENT__WALKINS__CANCELLED_ON__COLUMN_ID = "284cd186-c0ee-4fd1-b37f-22ec02e94608" as Uuid;

export const EMOTORAD__EVENT__WALKINS__CANCELLATION_REMARKS__COLUMN_ID = "73db3797-c28c-4775-8fe0-ff0fb58c9f64" as Uuid;

export const EMOTORAD__EVENT__WALKINS__LEAD_OWNER__COLUMN_ID = "b045b78e-5f6c-45f3-9ce7-9f6fb0468b6d" as Uuid;

export const EMOTORAD__EVENT__WALKINS__CUSTOMER_PINCODE__COLUMN_ID = "9ac32bc2-9b98-4bac-b81e-9c3ef0306dbb" as Uuid;

export const EMOTORAD__EVENT__WALKINS__MODEL_VARIANT__COLUMN_ID = "1730ebce-66c9-4dbe-8157-1a9a6e158934" as Uuid;

export const EMOTORAD__EVENT__WALKINS__LAST_WALKIN_DATE__COLUMN_ID = "20642ba3-22e6-4068-9e8f-3147c1c72169" as Uuid;

export const EMOTORAD__EVENT__WALKINS__CUSTOMER_STATE__COLUMN_ID = "03aa77f3-0e69-48f3-98f8-1f0035192957" as Uuid;

export const EMOTORAD__EVENT__WALKINS__CUSTOMER_CITY__COLUMN_ID = "7c9cae0a-6831-49b8-a516-1835635f74e1" as Uuid;

export const EMOTORAD__EVENT__WALKINS__CURRENT_PLATFORM__COLUMN_ID = "393680df-832e-4bf3-9341-dd0fa34b55b4" as Uuid;

export const EMOTORAD__EVENT__WALKINS__PURCHASE_TIMELINE__COLUMN_ID = "cfde3e40-e66f-4e39-82aa-d84130327ff7" as Uuid;

export const EMOTORAD__EVENT__WALKINS__EXPLORING_FOR__COLUMN_ID = "cd44d505-b92f-4a7d-a529-03a0dac3ec73" as Uuid;

export const EMOTORAD__EVENT__WALKINS__PRIMARY_RIDING_PURPOSE__COLUMN_ID = "563d0867-39c8-4dd7-81e1-b122ab1985ca" as Uuid;

export const EMOTORAD__EVENT__WALKINS__HEIGHT_OF_RIDER__COLUMN_ID = "dca5e668-6487-4d3d-ba33-f18578dc0004" as Uuid;

export const EMOTORAD__EVENT__WALKINS__EXPECTED_RIDING_FREQUENCY__COLUMN_ID = "92ba552f-3e0d-4bfb-ad15-5ed7e5c12e77" as Uuid;

export const EMOTORAD__EVENT__WALKINS__MODIFIED_BY__COLUMN_ID = "7b68690e-76f7-4744-878a-49e8a5bea1b3" as Uuid;

export const EMOTORAD__EVENT__WALKINS__MODIFIED_ON__COLUMN_ID = "b2065eef-46ee-43e2-a0bc-37ef66cb8e65" as Uuid;

export const EMOTORAD__EVENT__WALKINS__UTM_PLATFORM__COLUMN_ID = "080219ed-f4c4-4c0c-b5eb-29907bae08a3" as Uuid;

export const EMOTORAD__EVENT__WALKINS__UTM_SOURCE__COLUMN_ID = "8600da08-5c98-42ef-abf4-d12cddaaf3d9" as Uuid;

export const EMOTORAD__EVENT__WALKINS__UTM_MEDIUM__COLUMN_ID = "ccfebeb8-a389-4ce3-b8fd-2f769f650773" as Uuid;

export const EMOTORAD__EVENT__WALKINS__UTM_CAMPAIGN__COLUMN_ID = "85b9af15-11e5-4cf9-acb5-fa48ce006e4c" as Uuid;

export const EMOTORAD__EVENT__WALKINS__UTM_TERM__COLUMN_ID = "76189091-60c9-4752-928f-e4a160aa0094" as Uuid;

export const EMOTORAD__EVENT__WALKINS__UTM_CONTENT__COLUMN_ID = "2a8e7d39-24ec-4b69-998f-fc22d24180e0" as Uuid;

export const EMOTORAD__EVENT__WALKINS__FOLLOW_UP_REQUIRED__COLUMN_ID = "3d474433-0197-49ad-a050-9903caabed7b" as Uuid;

export const EMOTORAD__EVENT__WALKINS__FOLLOW_UP_DATE__COLUMN_ID = "b35df6f7-806e-4d23-9a08-d6f4c7bc79c1" as Uuid;

export const EMOTORAD__EVENT__WALKINS__INPUT_TYPE__COLUMN_ID = "c193e6b2-97dd-409b-b699-53ad09c18b30" as Uuid;

export const EMOTORAD__EVENT__WALKINS__INPUT_SOURCE__COLUMN_ID = "4543cd37-aa7d-4d09-a2d3-39010da2afac" as Uuid;

export const EMOTORAD__EVENT__WALKINS__TEST_RIDE_TAKEN__COLUMN_ID = "ffee454f-fb2a-47d9-a36e-c2fc2cd8fbc9" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__STATUS__COLUMN_ID = "aa4838d1-00c7-4ea9-ab96-450558dbc7d8" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__DISPOSITION__COLUMN_ID = "14110356-342e-4179-b1f7-0fbaa41ac4e1" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__REMARKS__COLUMN_ID = "45ec293b-9903-4bff-993c-6632bb8fc2c2" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__SCHEDULED_BY__COLUMN_ID = "c776b7b0-e80e-4265-b7bc-5278734d8ec2" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__SCHEDULED_ON__COLUMN_ID = "302f54ac-11cb-4b4c-a498-35242730f08b" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__LOGGED_BY__COLUMN_ID = "67430e3f-6ff7-4a9f-a59c-9ed01effef97" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__LOGGED_ON__COLUMN_ID = "d1dd1e0f-970c-4f0f-a416-9e76c164c948" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__CANCELLED_BY__COLUMN_ID = "be53b280-92f0-46d9-b012-742d3d46ede8" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__CANCELLED_ON__COLUMN_ID = "7baafb01-0c27-47cf-b87e-03c29a916f1b" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__CANCELLATION_REMARKS__COLUMN_ID = "39221a51-1fc2-4e65-bb14-5ad2ebcf9fb3" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__LEAD_OWNER__COLUMN_ID = "05b65982-1f9b-4aaa-a6db-1c84d01e5cdb" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__CUSTOMER_PINCODE__COLUMN_ID = "6658f679-d4f0-4820-8e0e-c06b320e9bcf" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__MODEL_VARIANT__COLUMN_ID = "10e76dce-3dd1-49bd-8620-46807d461ff7" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__LAST_TEST_RIDE_DATE__COLUMN_ID = "2bc475c0-d6bf-4394-98cb-e33cab74f85c" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__TEST_RIDE_DATE__COLUMN_ID = "b80e141c-3882-434d-aacf-4ab649507c7e" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__TEST_RIDE_TIME__COLUMN_ID = "8b9adeae-747e-4335-a928-3ddb9eb2f120" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__CUSTOMER_STATE__COLUMN_ID = "7cb53b65-6354-44c6-b446-89506d53eae2" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__CUSTOMER_CITY__COLUMN_ID = "31e23791-8d6d-4db3-bb30-a3e10779e5f6" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__CURRENT_PLATFORM__COLUMN_ID = "750ac9ec-2071-4ce7-a345-f7241df4c490" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__PURCHASE_TIMELINE__COLUMN_ID = "12faaf41-9fc1-489d-9dce-e3ecb26a3905" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__EXPLORING_FOR__COLUMN_ID = "601b901d-cb4d-475c-8e55-63fd35aaec57" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__PRIMARY_RIDING_PURPOSE__COLUMN_ID = "bcfd1dcd-9c36-4659-b087-728be52b4ff3" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__HEIGHT_OF_RIDER__COLUMN_ID = "b6dbd229-c40c-4f66-9184-717b20b93d30" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__EXPECTED_RIDING_FREQUENCY__COLUMN_ID = "f42b48c0-1c32-4a26-b8eb-093c660aa581" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__MODIFIED_BY__COLUMN_ID = "6305f844-8fe2-4adf-9f1b-99331ec2c6c5" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__MODIFIED_ON__COLUMN_ID = "4d145dc3-2d92-49d6-ad6c-b63b1431eb9f" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__UTM_PLATFORM__COLUMN_ID = "ba3dde36-2cbf-476a-b8ef-d4913adf64c3" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__UTM_SOURCE__COLUMN_ID = "90638b76-7c02-4e0c-bef8-52712e19796e" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__UTM_MEDIUM__COLUMN_ID = "a8eb24ac-3942-4d8a-a178-bf356f914832" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__UTM_CAMPAIGN__COLUMN_ID = "6d396fd0-4d38-48c0-bc21-782c8a1a0629" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__UTM_TERM__COLUMN_ID = "a2cffa5a-f7ef-44a7-8a82-b98afed0257b" as Uuid;

export const EMOTORAD__EVENT__TESTRIDES__UTM_CONTENT__COLUMN_ID = "da9dfbd0-87e9-4595-820f-b557237f4fc2" as Uuid;

export const EMOTORAD__EVENT__SALES__STATUS__COLUMN_ID = "26db9b07-e04e-4714-a605-af27a851dc04" as Uuid;

export const EMOTORAD__EVENT__SALES__FRAME_NUMBER__COLUMN_ID = "8e83e6e6-6362-4284-b3f4-0ea558bc97f0" as Uuid;

export const EMOTORAD__EVENT__SALES__CLOSED_ON__COLUMN_ID = "8f8dbbac-2790-4538-bcec-68822e2479d0" as Uuid;

export const EMOTORAD__EVENT__SALES__REMARKS__COLUMN_ID = "6a85542c-8cbc-4c3b-b624-ea6db46bc96e" as Uuid;

export const EMOTORAD__EVENT__SALES__MODEL_VARIANT__COLUMN_ID = "1372f9bd-281d-4b15-a2c5-24dd23aa6174" as Uuid;

export const EMOTORAD__EVENT__SALES__MODEL__COLUMN_ID = "08d23c06-cc09-433b-b1b3-a93283a14ba8" as Uuid;

export const EMOTORAD__EVENT__SALES__CUSTOMER_PINCODE__COLUMN_ID = "cf0c7e44-7e1a-4a3e-9a06-8073293b73d0" as Uuid;

export const EMOTORAD__EVENT__SALES__ORIGIN_PLATFORM__COLUMN_ID = "01594c77-0526-487f-8137-e67ee64b1491" as Uuid;

export const EMOTORAD__EVENT__SALES__ACTION_PLATFORM__COLUMN_ID = "2f71fe66-6dac-44c8-b793-68587c93c26c" as Uuid;

export const EMOTORAD__EVENT__SALES__ACTION_OWNER__COLUMN_ID = "25e81eee-506f-453b-895c-7e65d881808d" as Uuid;

export const EMOTORAD__EVENT__SALES__SOURCE_CHANNEL__COLUMN_ID = "444eea35-6c58-4b4c-bfc6-d4299a4bc650" as Uuid;

export const EMOTORAD__EVENT__SALES__FRANCHISE_ID__COLUMN_ID = "acfbf069-a5e4-498f-96ed-2b918764e334" as Uuid;

export const EMOTORAD__EVENT__SALES__CREATED_BY_ROLE__COLUMN_ID = "ec5fa969-4e5e-4705-92be-86dea7ec5759" as Uuid;

export const EMOTORAD__EVENT__SALES__LAYOUT__COLUMN_ID = "b8f10c0c-1786-4743-b5a1-392a6aa602a1" as Uuid;

export const EMOTORAD__EVENT__SALES__PREFERRED_COLOR__COLUMN_ID = "a5a57c39-6bfe-4290-8198-2aeab14bbd38" as Uuid;

export const EMOTORAD__EVENT__SALES__CUSTOMER_CITY__COLUMN_ID = "bdc91a4c-4155-42df-968c-63b847fac464" as Uuid;

export const EMOTORAD__EVENT__SALES__CUSTOMER_STATE__COLUMN_ID = "acd9870b-59a4-43e6-b709-920b9ec06654" as Uuid;

export const EMOTORAD__EVENT__SALES__PURCHASE_TIMELINE__COLUMN_ID = "ff14e7f8-95ce-4cdf-8c84-d6f30ce4a2af" as Uuid;

export const EMOTORAD__EVENT__SALES__SHOWROOM_PINCODE__COLUMN_ID = "e60e409e-85d6-40cc-abb9-e08017cf43f3" as Uuid;

export const EMOTORAD__EVENT__SALES__SHOWROOM_CITY__COLUMN_ID = "8ea7074b-fa80-4a07-a2ce-e654bedbb5ba" as Uuid;

export const EMOTORAD__EVENT__SALES__SHOWROOM_STATE__COLUMN_ID = "10140fb4-93b9-47db-9e53-389e488c1a58" as Uuid;

export const EMOTORAD__EVENT__SALES__SHOWROOM_ZONE__COLUMN_ID = "3c1fa1c4-8977-48c1-80c4-e672c9fb14cb" as Uuid;

export const EMOTORAD__EVENT__SALES__SHOWROOM_ID__COLUMN_ID = "a6a59513-ca86-4df1-8573-0fe110ff98b4" as Uuid;

export const EMOTORAD__EVENT__SALES__UTM_SOURCE__COLUMN_ID = "792619c3-ee28-4198-a51f-7bf3be96ce35" as Uuid;

export const EMOTORAD__EVENT__SALES__UTM_MEDIUM__COLUMN_ID = "20a6eac5-b156-4362-a0e4-ea92d10c613c" as Uuid;

export const EMOTORAD__EVENT__SALES__UTM_CAMPAIGN__COLUMN_ID = "6bb3d8f4-511b-4783-8cf0-db3e6e893fd2" as Uuid;

export const EMOTORAD__EVENT__SALES__UTM_TERM__COLUMN_ID = "c39ba183-62c4-4375-9c58-ed3f06a12a17" as Uuid;

export const EMOTORAD__EVENT__SALES__UTM_CONTENT__COLUMN_ID = "066cdcc3-5e3d-41c2-bdcc-f28f122f78b6" as Uuid;

export const EMOTORAD__EVENT__SALES__CREATED_BY_NAME__COLUMN_ID = "317f2a9a-f6e8-466e-834e-361b649da5ca" as Uuid;

export const EMOTORAD__EVENT__SALES__CUSTOMER_OWNER__COLUMN_ID = "9c06319c-098b-4d75-bee3-8b6db3d1222a" as Uuid;

export const EMOTORAD__EVENT__SALES__ACTION_OWNER_CONTACT__COLUMN_ID = "3e43ae46-a7df-4098-a336-9f837e1efaea" as Uuid;

export const EMOTORAD__EVENT__SALES__ACTION_OWNER_ID__COLUMN_ID = "72929da6-f7ab-45c6-a3ae-53fed4d1484e" as Uuid;

export const EMOTORAD__EVENT__SALES__ALTERNATE_CONTACT__COLUMN_ID = "de9fa451-4a29-4f34-b33a-843c7bc1a36b" as Uuid;

export const EMOTORAD__EVENT__SALES__SHOWROOM_CONTACT__COLUMN_ID = "dde1ece1-4377-4b67-9363-d04d3b10b465" as Uuid;

export const EMOTORAD__EVENT__SALES__SHOWROOM_MAIL__COLUMN_ID = "386ac5b7-d380-4abd-8540-16e1aefc294d" as Uuid;

export const EMOTORAD__EVENT__SALES__KAM__COLUMN_ID = "ce2fafb7-b54d-46b9-8b64-33a94bb1eaef" as Uuid;

export const EMOTORAD__EVENT__SALES__RM__COLUMN_ID = "9263f724-fd00-473c-b1e0-bf4658a3b392" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__DIGITAL_LEAD_STATUS__COLUMN_ID = "6b57e207-2c15-5575-a0c4-8c1eae5cd686" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__UTM_PLATFORM__COLUMN_ID = "b3abd08f-931b-5808-8222-c56d5382987c" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__UTM_SOURCE__COLUMN_ID = "dee27efb-806d-5ade-be52-4473db9baf15" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__UTM_MEDIUM__COLUMN_ID = "b896252a-d0fc-5de9-9023-0c5eaf00320c" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__UTM_CAMPAIGN__COLUMN_ID = "9bbd11e7-9659-5351-ae38-5e05c091e022" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__UTM_TERM__COLUMN_ID = "67f3ac15-775f-5c11-85ba-6860eac0f9ca" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__UTM_CONTENT__COLUMN_ID = "0fe27549-75e8-5ca1-aa96-f6d16bf9ecd1" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__FBCLID__COLUMN_ID = "81ec1852-b7ba-58df-8f6c-da36a629b57e" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__GCLID__COLUMN_ID = "e02309e4-2679-5403-9b72-e37a23d6851e" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__CUSTOMER_PINCODE__COLUMN_ID = "a79ad7d0-7b84-4f1e-9d0c-68f00825b667" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__MODEL_VARIANT__COLUMN_ID = "5046e232-009a-4776-b57e-467ec6207dd5" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__MODEL__COLUMN_ID = "cace5e77-6b7a-448b-88c3-8faa9312ccd0" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__LEAD_STATUS__COLUMN_ID = "256d8bf2-0846-4b31-b9a3-70bc2880628c" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__CURRENT_VEHICLE__COLUMN_ID = "b92a4a2e-d4bc-4675-bf17-39ab8b2d3414" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__AON__COLUMN_ID = "594dae7d-2c8b-4e39-9d7c-e9861bf89c96" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__CURRENT_PLATFORM__COLUMN_ID = "82a27937-79ad-4c6a-9cec-ed6e43bf851a" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__CATEGORY__COLUMN_ID = "aa9940fb-93c7-4ffd-a016-a1885f03f8f8" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__PURCHASE_TIMELINE__COLUMN_ID = "b608f104-71c0-45f1-a665-467fa97514af" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__GENDER__COLUMN_ID = "ad45f601-58ce-4c52-aa37-13c42678104f" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__CUSTOMER_CITY__COLUMN_ID = "d9468492-24e3-4a8a-b2eb-67ce1b0027d3" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__CUSTOMER_STATE__COLUMN_ID = "aac79bc4-4176-4fcb-9fa1-4ba3f92bf31f" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__CUSTOMER_HOUSE_NO__COLUMN_ID = "54bca2f1-0eb4-43e7-92a9-46a17575b7be" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__CUSTOMER_LANDMARK__COLUMN_ID = "e6ae0a9b-f12d-4051-99a4-4d2e1282a114" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__PRIMARY_RIDING_PURPOSE__COLUMN_ID = "4c1eaedb-d2db-4bf0-bfa9-4677cef0f421" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__EXPLORING_FOR__COLUMN_ID = "2d1d744a-fa0c-4e5c-b7d6-67c7b27be63c" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__EXPECTED_RIDING_FREQUENCY__COLUMN_ID = "d4fb9821-97f7-48f5-bd1d-9a4ea6d2d78c" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__HEIGHT_OF_RIDER__COLUMN_ID = "773cd07f-d2b1-49a1-8ec9-de822ee6f7d3" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__FIRST_CYCLE__COLUMN_ID = "51142a6d-52e4-4914-812c-bc600f6bdcac" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__PREFERRED_COLOR__COLUMN_ID = "af99ce3b-9518-4fcb-bf73-b4db38763907" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__OTHER_BRANDS_CONSIDERED__COLUMN_ID = "e79f7aa2-6af3-4d27-a85b-55fa25825404" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__SOURCE_CHANNEL__COLUMN_ID = "97fb5543-2766-42a2-a6aa-838dc1f260f8" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__CREATED_BY_ROLE__COLUMN_ID = "f5178ee2-527d-47df-9a1e-b54ff34da4cd" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__CREATED_BY_NAME__COLUMN_ID = "b5576aae-b9dc-4937-abba-dccfdb25275f" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__ASSIGNED_ON__COLUMN_ID = "aa1d694a-dad2-40c3-8502-3893b04b696e" as Uuid;

export const EMOTORAD__EVENT__ENQUIRY__MODIFIED_ON__COLUMN_ID = "475ea1d0-fdfe-4b68-9e58-3c3e1aa76b19" as Uuid;

export const EMOTORAD__EVENT__CALL__FBCLID__COLUMN_ID = "2817d794-829d-5d83-8883-567cf5446dd5" as Uuid;

export const EMOTORAD__EVENT__CALL__GCLID__COLUMN_ID = "c0bbfe25-d06e-56be-be60-f34f65039ed5" as Uuid;

export enum EventCallType {
    "inbound" = "e020499b-f145-57d2-a38f-da44d9710ff9",
    "outBound" = "01ced098-9ea5-5051-8543-ab2551564819",
}

export enum EmotoradCallStatusEnum {
    SCHEDULED = "ce68622b-2021-5a49-8f32-e0fb86549d66",
    CANCELLED = "41a9a2da-9ed9-5ba9-8d36-19c0888cb51e",
    LOGGED = "b37cf97d-c25a-52aa-9123-f1f934522321",
    ARCHIVE = "77b2f41a-6d8f-577d-b575-4a65be666d7a",
}

export enum EmotoradSalesStatusEnum {
    UNVERIFIED = "7b42c5d1-6b9a-46c1-824f-28a4295e5218",
    VERIFIED = "c79be980-5697-4510-80ad-47e8b1f71a0a",
    ARCHIVE = "dacf820a-c363-44be-be85-109149beee45",
}

export enum EmotoradSalesEventDispositionEnum {
    UNVERIFIED,
    VERIFIED,
    ARCHIVE,
}

export enum EmotoradEventCallDispositionEnum {
    LOGGED,
    SCHEDULED,
    CANCELLED,
}

export enum EmotoradInputTypeEnum {
    ACTIVITY = "60741ff1-69a1-4bb3-8a3c-0175e7aa964a",
    DIRECT = "ef715ecb-a4ed-421e-be9f-00b31d53e169",
}

export enum EmotoradInputSourceEnum {
    CALL = "8ba801a2-df74-4995-b836-10e6253d32a1",
    WALKIN = "bddeaa8e-89f3-495c-91f5-73c26c633494",
    PROFILE_ACTION = "aad8d622-5416-4cfa-ad0b-3a15b2467496",
}

export enum EmotoradLeadEventStatusEnum {
    OPEN = "fb9def24-4505-46c5-b810-220ec1b12474",
    ENGAGED = "d4c61d77-4729-475b-9476-268179600cf2",
    NON_ENGAGED = "bca0583d-4a03-4259-b8f9-33876998015e",
    DUPLICATE = "a5c75ee0-9c9c-403e-a802-55ce492bc570",
    ARCHIVE = "1bb5e271-bd1b-437e-90fd-7601580c6c3c",
}

export const emotoradCallStatuses: Record<
    EmotoradCallStatusEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [EmotoradCallStatusEnum.SCHEDULED]: {
        id: EmotoradCallStatusEnum.SCHEDULED as Uuid,
        displayName: "Scheduled",
    },
    [EmotoradCallStatusEnum.CANCELLED]: {
        id: EmotoradCallStatusEnum.CANCELLED as Uuid,
        displayName: "Cancelled",
    },
    [EmotoradCallStatusEnum.LOGGED]: {
        id: EmotoradCallStatusEnum.LOGGED as Uuid,
        displayName: "Logged",
    },
    [EmotoradCallStatusEnum.ARCHIVE]: {
        id: EmotoradCallStatusEnum.ARCHIVE as Uuid,
        displayName: "Archive",
    },
};

/** Sale (retail) row lifecycle — emotoradSetup.csv §7. */
export const emotoradSalesStatuses: Record<
    EmotoradSalesStatusEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [EmotoradSalesStatusEnum.UNVERIFIED]: {
        id: EmotoradSalesStatusEnum.UNVERIFIED as Uuid,
        displayName: "Unverified",
    },
    [EmotoradSalesStatusEnum.VERIFIED]: {
        id: EmotoradSalesStatusEnum.VERIFIED as Uuid,
        displayName: "Verified",
    },
    [EmotoradSalesStatusEnum.ARCHIVE]: {
        id: EmotoradSalesStatusEnum.ARCHIVE as Uuid,
        displayName: "Archive",
    },
};

/** Event-template disposition rows for sales template (parallel to call Logged/Scheduled/Cancelled). */
export const emotoradSalesEventDispositions: Record<
    EmotoradSalesEventDispositionEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [EmotoradSalesEventDispositionEnum.UNVERIFIED]: {
        id: "e42e6c98-a55c-4af0-a2d0-69ff9863937d" as Uuid,
        displayName: "Unverified",
    },
    [EmotoradSalesEventDispositionEnum.VERIFIED]: {
        id: "3cf089c6-cd5c-4165-9b8e-a4c9da0e2826" as Uuid,
        displayName: "Verified",
    },
    [EmotoradSalesEventDispositionEnum.ARCHIVE]: {
        id: "c1b8e54c-4c81-409c-adcd-4148ad47f603" as Uuid,
        displayName: "Archive",
    },
};

/** Event-template disposition rows (Logged / Scheduled / Cancelled) for calls. */
export const emotoradEventCallDispositions: Record<
    EmotoradEventCallDispositionEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [EmotoradEventCallDispositionEnum.LOGGED]: {
        id: "a5cf96bc-f791-5f20-9af1-a4f2f7947380" as Uuid,
        displayName: "Logged",
    },
    [EmotoradEventCallDispositionEnum.SCHEDULED]: {
        id: "98cbce6e-3e61-5ee0-9801-88b785acfb06" as Uuid,
        displayName: "Scheduled",
    },
    [EmotoradEventCallDispositionEnum.CANCELLED]: {
        id: "83eef94a-df94-5790-bc86-68b502ff8491" as Uuid,
        displayName: "Cancelled",
    },
};

/** Input type — call and walk-in events. */
export const emotoradInputTypes: Record<EmotoradInputTypeEnum, {id: Uuid; displayName: string}> = {
    [EmotoradInputTypeEnum.ACTIVITY]: {
        id: EmotoradInputTypeEnum.ACTIVITY as Uuid,
        displayName: "Activity",
    },
    [EmotoradInputTypeEnum.DIRECT]: {
        id: EmotoradInputTypeEnum.DIRECT as Uuid,
        displayName: "Direct",
    },
};

export const getEmotoradInputTypeSelectOptions = () => Object.values(emotoradInputTypes);

/** Input source — call and walk-in events. */
export const emotoradInputSources: Record<EmotoradInputSourceEnum, {id: Uuid; displayName: string}> = {
    [EmotoradInputSourceEnum.CALL]: {
        id: EmotoradInputSourceEnum.CALL as Uuid,
        displayName: "Call",
    },
    [EmotoradInputSourceEnum.WALKIN]: {
        id: EmotoradInputSourceEnum.WALKIN as Uuid,
        displayName: "Walkin",
    },
    [EmotoradInputSourceEnum.PROFILE_ACTION]: {
        id: EmotoradInputSourceEnum.PROFILE_ACTION as Uuid,
        displayName: "Profile Action",
    },
};

export const getEmotoradInputSourceSelectOptions = () => Object.values(emotoradInputSources);

export const getEmotoradCallStatuses = () => Object.values(emotoradCallStatuses);

export const getEmotoradSalesStatuses = () => Object.values(emotoradSalesStatuses);

export const getEmotoradSalesEventDispositions = () => Object.values(emotoradSalesEventDispositions);

export const getEmotoradEventCallDispositions = () => Object.values(emotoradEventCallDispositions);

/** Lead event row status — emotoradSetup.csv §3 (Open / Engaged / …). */
export const emotoradLeadEventStatuses: Record<EmotoradLeadEventStatusEnum, {id: Uuid; displayName: string}> = {
    [EmotoradLeadEventStatusEnum.OPEN]: {
        id: EmotoradLeadEventStatusEnum.OPEN as Uuid,
        displayName: "Open",
    },
    [EmotoradLeadEventStatusEnum.ENGAGED]: {
        id: EmotoradLeadEventStatusEnum.ENGAGED as Uuid,
        displayName: "Engaged",
    },
    [EmotoradLeadEventStatusEnum.NON_ENGAGED]: {
        id: EmotoradLeadEventStatusEnum.NON_ENGAGED as Uuid,
        displayName: "Non-Engaged",
    },
    [EmotoradLeadEventStatusEnum.DUPLICATE]: {
        id: EmotoradLeadEventStatusEnum.DUPLICATE as Uuid,
        displayName: "Duplicate",
    },
    [EmotoradLeadEventStatusEnum.ARCHIVE]: {
        id: EmotoradLeadEventStatusEnum.ARCHIVE as Uuid,
        displayName: "Archive",
    },
};

export const getEmotoradLeadEventStatuses = () => Object.values(emotoradLeadEventStatuses);
